<template>
  <div>
    <app-breadcrumb title="My Alerts"></app-breadcrumb>
    <v-container fluid grid-list-xl pa-0>
      <v-layout row wrap>
        <v-flex xs12>
          <!--Multiple-->
          <app-card>
            <div class="app-card-header primary-actions">
              <div class="heading-block">
                <h4 class="heading">Multiple</h4>
              </div>
              <div class="actions-block">
                <v-btn
                  class="i-btn-hoverable"
                  color="primary"
                  flat
                  small
                  :ripple="false"
                  @click="openMultipleDialog($event, 1)"
                >
                  Add new alert<v-icon class="ml-1">add</v-icon>
                </v-btn>
                <v-btn
                  :disabled="multiple.selected.length < 1"
                  color="error"
                  flat
                  small
                  :ripple="false"
                  @click="deleteDialogHandler(multiple.selected, 'group', 'multiple')"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </div>
            </div>
            <div class="card-body pa-0">
              <v-progress-circular
                v-if="getAlerts.alerts.multiple.loading && !getAlerts.alerts.multiple.items.length"
                :indeterminate="true"
                :size="75"
                height="3"
                color="primary"
                class="progress-circular" />
              <v-progress-linear
                v-if="getAlerts.alerts.multiple.loading && getAlerts.alerts.multiple.items.length"
                :indeterminate="true"
                height="3"
                color="primary"
                class="progress-card" />
              <v-data-table
                v-if="!getAlerts.alerts.multiple.noData"
                v-model="multiple.selected"
                :items="getAlerts.alerts.multiple.items"
                :rows-per-page-items="multiple.rowsPerPageItems"
                :pagination.sync="multiple.pagination"
                :headers="multiple.headers"
                item-key="alert_id"
                :hide-actions="(getAlerts.alerts.multiple.loading && !getAlerts.alerts.multiple.items.length) || getAlerts.alerts.multiple.noData"
                :hide-headers="(getAlerts.alerts.multiple.loading && !getAlerts.alerts.multiple.items.length) || getAlerts.alerts.multiple.noData"
                no-data-text=""
                select-all
                class="i-table"
              >
                <template v-slot:items="props">
                  <tr>
                    <td class="dropdown-filter-primary align-center">
                      <v-checkbox
                        v-model="props.selected"
                        color="primary"
                        :ripple="false"
                        hide-details
                      ></v-checkbox>
                    </td>
                    <td>{{props.item.alert_name}}</td>
                    <td>{{props.item.seller}}</td>
                    <td>{{props.item.brand}}</td>
                    <td>{{props.item.category_1}}</td>
                    <td>{{props.item.category_2}}</td>
                    <td>{{props.item.category_3}}</td>
                    <td>{{props.item.receiving_time_1}}</td>
                    <td>{{props.item.receiving_time_2}}</td>
                    <td>{{props.item.dateCreated}}</td>
                    <td>
                      <v-btn
                        class="ma-0 pa-0 btn-table-action"
                        color="error"
                        flat
                        small
                        :ripple="false"
                        @click="deleteDialogHandler(props.item.alert_id, 'one', 'multiple')"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <i-no-data heading="Oops!" v-if="getAlerts.alerts.multiple.noData && (!getAlerts.alerts.multiple.loading && !getAlerts.alerts.multiple.items.length)" />
            </div>
          </app-card>

          <!--Add Dialog-->
          <v-dialog
            v-model="multiple.dialog.dialogOpen"
            transition="slide-x-transition"
            content-class="i-dialog"
            width="500"
            :dark="getThemeColor === '0'"
            attach
          >
            <v-card>
              <v-card-title
                class="headline"
                primary-title
              >
                Add New Multiple Alert
                <v-btn
                  class="modal-close-btn"
                  :ripple="false"
                  small
                  flat
                  solo
                  @click="closeMultipleDialog()"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </v-card-title>

              <v-form
                ref="multipleAlertForm"
                v-model="multiple.dialog.addAlert.valid"
                @submit.prevent="saveMultiple()"
              >
                <v-card-text class="dialog-dropdowns-list">
                  <v-layout>
                    <v-flex xs6>
                      <p>Alert Name</p>
                    </v-flex>
                    <v-flex xs6 py-0>
                      <v-text-field
                        v-model="multiple.dialog.addAlert.alertName.model"
                        class="i-v-text-field ma-0"
                        solo
                        flat
                        hide-details
                        placeholder="Alert Name"
                        :rules="[v => !!v || 'Item is required']"
                        validate-on-blur
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs6>
                      <p>Sellers</p>
                    </v-flex>
                    <v-flex xs6 py-0>
                      <div class="dropdown-filter-secondary">
                        <v-autocomplete
                          v-model="multiple.dialog.addAlert.sellers.model"
                          :items="getMultipleSellers"
                          :loading="multiple.dialog.addAlert.sellers.isLoading"
                          :search-input.sync="multiple.dialog.addAlert.sellers.search"
                          :ripple="false"
                          :rules="[v => !!v || 'Item is required']"
                          validate-on-blur
                          background-color="rgba(235, 237, 242, 0.5)"
                          clearable
                          attach
                          hide-details
                          clear-icon
                          append-icon="expand_more"
                          item-text="name"
                          item-value="id"
                          label="Sellers"
                          solo
                          flat
                        >
                          <template v-slot:item="{ item }">
                            <v-list-tile-content>
                              <v-list-tile-title :class="`option-level-${item.level}`" v-text="item.name"></v-list-tile-title>
                            </v-list-tile-content>
                          </template>
                        </v-autocomplete>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs6>
                      <p>Brands</p>
                    </v-flex>
                    <v-flex xs6 py-0>
                      <div class="dropdown-filter-secondary">
                        <v-autocomplete
                          v-model="multiple.dialog.addAlert.brands.model"
                          :items="getMultipleBrands"
                          :loading="multiple.dialog.addAlert.brands.isLoading"
                          :search-input.sync="multiple.dialog.addAlert.brands.search"
                          :ripple="false"
                          :rules="[v => !!v || 'Item is required']"
                          validate-on-blur
                          background-color="rgba(235, 237, 242, 0.5)"
                          clearable
                          attach
                          hide-details
                          clear-icon
                          append-icon="expand_more"
                          item-text="name"
                          item-value="id"
                          label="Brands"
                          solo
                          flat
                        >
                          <template v-slot:item="{ item }">
                            <v-list-tile-content>
                              <v-list-tile-title :class="`option-level-${item.level}`" v-text="item.name"></v-list-tile-title>
                            </v-list-tile-content>
                          </template>
                        </v-autocomplete>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs6>
                      <p>Categories</p>
                    </v-flex>
                    <v-flex xs6 py-0>
                      <div class="dropdown-filter-secondary">
                        <v-autocomplete
                          v-model="multiple.dialog.addAlert.categories.model"
                          :items="getMultipleCategories"
                          :loading="multiple.dialog.addAlert.categories.isLoading"
                          :search-input.sync="multiple.dialog.addAlert.categories.search"
                          :ripple="false"
                          :rules="[v => !!v || 'Item is required']"
                          validate-on-blur
                          background-color="rgba(235, 237, 242, 0.5)"
                          attach
                          clearable
                          hide-details
                          clear-icon
                          cache-items
                          append-icon="expand_more"
                          item-text="name"
                          item-value="id"
                          label="Categories"
                          solo
                          flat
                        >
                          <template v-slot:item="{ item }">
                            <v-list-tile-content>
                              <v-list-tile-title :class="`option-level-${item.level}`" v-text="item.name"></v-list-tile-title>
                            </v-list-tile-content>
                          </template>
                        </v-autocomplete>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs6>
                      <p>Receiving Time</p>
                    </v-flex>
                    <v-flex xs6 py-0>
                      <v-layout row wrap class="time-pick-dropdowns">
                        <v-flex md6 sm12 pr-1>
                          <div class="dropdown-filter-secondary clearable">
                            <v-autocomplete
                              v-model="multiple.dialog.addAlert.receive1.hours.model"
                              :items="hours"
                              :ripple="false"
                              :rules="[v => !!v || 'Item is required']"
                              validate-on-blur
                              background-color="rgba(235, 237, 242, 0.5)"
                              clearable
                              attach
                              hide-details
                              clear-icon="close"
                              cache-items
                              append-icon="access_time"
                              item-text="value"
                              item-value="key"
                              label="HH"
                              solo
                              flat
                            >
                              <template v-slot:item="{ item }">
                                <v-list-tile-content>
                                  <v-list-tile-title :class="`option-level-${item.level}`" v-text="item.value"></v-list-tile-title>
                                </v-list-tile-content>
                              </template>
                            </v-autocomplete>
                          </div>
                        </v-flex>
                        <v-flex md6 sm12 pl-1>
                          <div class="dropdown-filter-secondary clearable">
                            <v-autocomplete
                              v-model="multiple.dialog.addAlert.receive1.minutes.model"
                              :items="minutes"
                              :ripple="false"
                              :rules="[v => !!v || 'Item is required']"
                              validate-on-blur
                              background-color="rgba(235, 237, 242, 0.5)"
                              clearable
                              attach
                              hide-details
                              clear-icon="close"
                              cache-items
                              append-icon="access_time"
                              item-text="value"
                              item-value="key"
                              label="MM"
                              solo
                              flat
                            >
                              <template v-slot:item="{ item }">
                                <v-list-tile-content>
                                  <v-list-tile-title :class="`option-level-${item.level}`" v-text="item.value"></v-list-tile-title>
                                </v-list-tile-content>
                              </template>
                            </v-autocomplete>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs6>
                      <p>Receiving Time</p>
                    </v-flex>
                    <v-flex xs6 py-0>
                      <v-layout row wrap class="time-pick-dropdowns">
                        <v-flex md6 sm12 pr-1>
                          <div class="dropdown-filter-secondary clearable">
                            <v-autocomplete
                              v-model="multiple.dialog.addAlert.receive2.hours.model"
                              :items="hours"
                              :ripple="false"
                              :rules="[v => !!v || 'Item is required']"
                              validate-on-blur
                              background-color="rgba(235, 237, 242, 0.5)"
                              clearable
                              attach
                              hide-details
                              clear-icon="close"
                              cache-items
                              append-icon="access_time"
                              item-text="value"
                              item-value="key"
                              label="HH"
                              solo
                              flat
                            >
                              <template v-slot:item="{ item }">
                                <v-list-tile-content>
                                  <v-list-tile-title :class="`option-level-${item.level}`" v-text="item.value"></v-list-tile-title>
                                </v-list-tile-content>
                              </template>
                            </v-autocomplete>
                          </div>
                        </v-flex>
                        <v-flex md6 sm12 pl-1>
                          <div class="dropdown-filter-secondary clearable">
                            <v-autocomplete
                              v-model="multiple.dialog.addAlert.receive2.minutes.model"
                              :items="minutes"
                              :ripple="false"
                              :rules="[v => !!v || 'Item is required']"
                              validate-on-blur
                              background-color="rgba(235, 237, 242, 0.5)"
                              clearable
                              attach
                              hide-details
                              clear-icon="close"
                              cache-items
                              append-icon="access_time"
                              item-text="value"
                              item-value="key"
                              label="MM"
                              solo
                              flat
                            >
                              <template v-slot:item="{ item }">
                                <v-list-tile-content>
                                  <v-list-tile-title :class="`option-level-${item.level}`" v-text="item.value"></v-list-tile-title>
                                </v-list-tile-content>
                              </template>
                            </v-autocomplete>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <transition name="slide-fade" mode="out-in">
                    <div>
                      <div v-if="multiple.dialog.addAlert.errorMsg" class="i-alert error mt-3">
                        <img src="../assets/img/icons/danger.svg" alt="">
                        <p>You can have either 'All' brands or 'All' categories but not both of them!</p>
                      </div>
                    </div>
                  </transition>
                  <div class="text-xs-right">
                    <v-btn
                      class="i-btn-hoverable text-normal mx-0 mt-3"
                      flat
                      color="primary"
                      :ripple="false"
                      type="submit"
                      :disabled="multiple.dialog.addAlert.valid"
                    >
                      Save
                    </v-btn>
                  </div>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
        </v-flex>

        <v-flex xs12>
          <!--Single-->
          <app-card>
            <div class="app-card-header primary-actions">
              <div class="heading-block">
                <h4 class="heading">Single</h4>
              </div>
              <div class="actions-block">
                <v-btn
                  class="i-btn-hoverable"
                  color="primary"
                  flat
                  small
                  :ripple="false"
                  @click="openSingleDialog($event, 2)"
                >
                  Add new alert<v-icon class="ml-1">add</v-icon>
                </v-btn>
                <v-btn
                  :disabled="single.selected.length < 1"
                  color="error"
                  flat
                  small
                  :ripple="false"
                  @click="deleteDialogHandler(single.selected, 'group', 'single')"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </div>
            </div>
            <div class="card-body pa-0">
              <v-progress-circular
                v-if="getAlerts.alerts.single.loading && !getAlerts.alerts.single.items.length"
                :indeterminate="true"
                :size="75"
                height="3"
                color="primary"
                class="progress-circular" />
              <v-progress-linear
                v-if="getAlerts.alerts.single.loading && getAlerts.alerts.single.items.length"
                :indeterminate="true"
                height="3"
                color="primary"
                class="progress-card" />
              <v-data-table
                v-if="!getAlerts.alerts.single.noData"
                v-model="single.selected"
                :items="getAlerts.alerts.single.items"
                :rows-per-page-items="single.rowsPerPageItems"
                :pagination.sync="single.pagination"
                :headers="single.headers"
                :hide-actions="(getAlerts.alerts.single.loading && !getAlerts.alerts.single.items.length) || getAlerts.alerts.single.noData"
                :hide-headers="(getAlerts.alerts.single.loading && !getAlerts.alerts.single.items.length) || getAlerts.alerts.single.noData"
                no-data-text=""
                item-key="alert_id"
                select-all
                class="i-table"
              >
                <template v-slot:items="props">
                  <tr>
                    <td class="dropdown-filter-primary align-center">
                      <v-checkbox
                        v-model="props.selected"
                        color="primary"
                        :ripple="false"
                        hide-details
                      ></v-checkbox>
                    </td>
                    <td>{{props.item.alert_name}}</td>
                    <td>{{props.item.seller}}</td>
                    <td>{{props.item.brand}}</td>
                    <td>{{props.item.productName}}</td>
                    <td>{{props.item.sku}}</td>
<!--                    <td>{{props.item.receiving_time_1}}</td>-->
<!--                    <td>{{props.item.receiving_time_2}}</td>-->
                    <td>{{props.item.dateCreated}}</td>
                    <td>
                      <v-btn
                        class="ma-0 pa-0 btn-table-action"
                        color="error"
                        flat
                        small
                        :ripple="false"
                        @click="deleteDialogHandler(props.item.alert_id, 'one', 'single')"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <i-no-data heading="Oops!" v-if="getAlerts.alerts.single.noData && (!getAlerts.alerts.single.loading && !getAlerts.alerts.single.items.length)" />
            </div>
          </app-card>

          <!--Add Dialog-->
          <v-dialog
            v-model="single.dialog.dialogOpen"
            transition="slide-x-transition"
            content-class="i-dialog"
            width="500"
            :dark="getThemeColor === '0'"
            attach
          >
            <v-card>
              <v-card-title
                class="headline"
                primary-title
              >
                Add New Single Alert
                <v-btn
                  class="modal-close-btn"
                  :ripple="false"
                  small
                  flat
                  solo
                  @click="closeSingleDialog()"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </v-card-title>

              <v-form
                ref="singleAlertForm"
                v-model="single.dialog.addAlert.valid"
                @submit.prevent="saveSingle()"
              >
                <v-card-text class="dialog-dropdowns-list">
                  <v-layout>
                    <v-flex xs6>
                      <p>Alert Name</p>
                    </v-flex>
                    <v-flex xs6 py-0>
                      <v-text-field
                        v-model="single.dialog.addAlert.alertName.model"
                        class="i-v-text-field ma-0"
                        solo
                        flat
                        hide-details
                        placeholder="Alert Name"
                        :rules="[v => !!v || 'Item is required']"
                        validate-on-blur
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs6>
                      <p>Seller</p>
                    </v-flex>
                    <v-flex xs6 py-0>
                      <div class="dropdown-filter-secondary">
                        <v-autocomplete
                          v-model="single.dialog.addAlert.sellers.model"
                          :items="getSingleSellers"
                          :loading="single.dialog.addAlert.sellers.isLoading"
                          :search-input.sync="single.dialog.addAlert.sellers.search"
                          :ripple="false"
                          :rules="[v => !!v || 'Item is required']"
                          background-color="rgba(235, 237, 242, 0.5)"
                          attach
                          clearable
                          hide-details
                          clear-icon
                          append-icon="expand_more"
                          item-text="name"
                          item-value="id"
                          label="Seller"
                          solo
                          flat
                        >
                          <template v-slot:item="{ item }">
                            <v-list-tile-content>
                              <v-list-tile-title :class="`option-level-${item.level}`" v-text="item.name"></v-list-tile-title>
                            </v-list-tile-content>
                          </template>
                        </v-autocomplete>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs6>
                      <p>Brand</p>
                    </v-flex>
                    <v-flex xs6 py-0>
                      <v-text-field
                        v-model="single.dialog.addAlert.brands.search"
                        class="i-v-text-field ma-0"
                        solo
                        flat
                        hide-details
                        placeholder="Brand Name"
                        :disabled="true"
                      >
                      </v-text-field>
<!--                      <div class="dropdown-filter-secondary">-->
<!--                        <v-autocomplete-->
<!--                          v-model="single.dialog.addAlert.brands.model"-->
<!--                          :items="getSingleBrands"-->
<!--                          :loading="single.dialog.addAlert.brands.isLoading"-->
<!--                          :search-input.sync="single.dialog.addAlert.brands.search"-->
<!--                          :ripple="false"-->
<!--                          :rules="[v => !!v || 'Item is required']"-->
<!--                          background-color="rgba(235, 237, 242, 0.5)"-->
<!--                          attach-->
<!--                          clearable-->
<!--                          hide-details-->
<!--                          clear-icon-->
<!--                          append-icon="expand_more"-->
<!--                          item-text="name"-->
<!--                          item-value="id"-->
<!--                          label="Brand"-->
<!--                          solo-->
<!--                          flat-->
<!--                        >-->
<!--                          <template v-slot:item="{ item }">-->
<!--                            <v-list-tile-content>-->
<!--                              <v-list-tile-title :class="`option-level-${item.level}`" v-text="item.name"></v-list-tile-title>-->
<!--                            </v-list-tile-content>-->
<!--                          </template>-->
<!--                        </v-autocomplete>-->
<!--                      </div>-->
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs6>
                      <p>Product name</p>
                    </v-flex>
                    <v-flex xs6 py-0>
                      <div class="dropdown-filter-secondary">
                        <v-autocomplete
                          v-model="single.dialog.addAlert.products.model"
                          :items="getSingleProducts"
                          :loading="single.dialog.addAlert.products.isLoading"
                          :search-input.sync="single.dialog.addAlert.products.search"
                          :ripple="false"
                          :rules="[v => !!v || 'Item is required']"
                          background-color="rgba(235, 237, 242, 0.5)"
                          attach
                          clearable
                          hide-details
                          clear-icon
                          append-icon="expand_more"
                          item-text="name"
                          item-value="id"
                          label="Product name"
                          solo
                          flat
                        >
                          <template v-slot:item="{ item }">
                            <v-list-tile-content @click="getBrand(item)">
                              <v-list-tile-title :class="`option-level-${item.level}`" v-text="item.name"></v-list-tile-title>
                            </v-list-tile-content>
                          </template>
                        </v-autocomplete>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs6>
                      <p>SKU</p>
                    </v-flex>
                    <v-flex xs6 py-0>
                      <div class="dropdown-filter-secondary">
                        <v-autocomplete
                          v-model="single.dialog.addAlert.sku.model"
                          :items="getSingleSkus"
                          :loading="single.dialog.addAlert.sku.isLoading"
                          :search-input.sync="single.dialog.addAlert.sku.search"
                          :ripple="false"
                          background-color="rgba(235, 237, 242, 0.5)"
                          attach
                          clearable
                          hide-details
                          clear-icon
                          append-icon="expand_more"
                          item-text="name"
                          item-value="id"
                          label="SKU"
                          solo
                          flat
                        >
                          <template v-slot:item="{ item }">
                            <v-list-tile-content @click="changeProductAndBrand(item)">
                              <v-list-tile-title :class="`option-level-${item.level}`" v-text="item.name"></v-list-tile-title>
                            </v-list-tile-content>
                          </template>
                        </v-autocomplete>
                      </div>
                    </v-flex>
                  </v-layout>
<!--                  <v-layout>-->
<!--                    <v-flex xs6>-->
<!--                      <p>Receiving Time</p>-->
<!--                    </v-flex>-->
<!--                    <v-flex xs6 py-0>-->
<!--                      <v-layout row wrap class="time-pick-dropdowns">-->
<!--                        <v-flex md6 sm12 pr-1>-->
<!--                          <div class="dropdown-filter-secondary clearable">-->
<!--                            <v-autocomplete-->
<!--                              v-model="single.dialog.addAlert.receive1.hours.model"-->
<!--                              :items="hours"-->
<!--                              :ripple="false"-->
<!--                              :rules="[v => !!v || 'Item is required']"-->
<!--                              validate-on-blur-->
<!--                              background-color="rgba(235, 237, 242, 0.5)"-->
<!--                              attach-->
<!--                              clearable-->
<!--                              hide-details-->
<!--                              clear-icon="close"-->
<!--                              cache-items-->
<!--                              append-icon="access_time"-->
<!--                              item-text="value"-->
<!--                              item-value="key"-->
<!--                              label="HH"-->
<!--                              solo-->
<!--                              flat-->
<!--                            >-->
<!--                              <template v-slot:item="{ item }">-->
<!--                                <v-list-tile-content>-->
<!--                                  <v-list-tile-title :class="`option-level-${item.level}`" v-text="item.value"></v-list-tile-title>-->
<!--                                </v-list-tile-content>-->
<!--                              </template>-->
<!--                            </v-autocomplete>-->
<!--                          </div>-->
<!--                        </v-flex>-->
<!--                        <v-flex md6 sm12 pl-1>-->
<!--                          <div class="dropdown-filter-secondary clearable">-->
<!--                            <v-autocomplete-->
<!--                              v-model="single.dialog.addAlert.receive1.minutes.model"-->
<!--                              :items="minutes"-->
<!--                              :ripple="false"-->
<!--                              :rules="[v => !!v || 'Item is required']"-->
<!--                              validate-on-blur-->
<!--                              background-color="rgba(235, 237, 242, 0.5)"-->
<!--                              attach-->
<!--                              clearable-->
<!--                              hide-details-->
<!--                              clear-icon="close"-->
<!--                              cache-items-->
<!--                              append-icon="access_time"-->
<!--                              item-text="value"-->
<!--                              item-value="key"-->
<!--                              label="MM"-->
<!--                              solo-->
<!--                              flat-->
<!--                            >-->
<!--                              <template v-slot:item="{ item }">-->
<!--                                <v-list-tile-content>-->
<!--                                  <v-list-tile-title :class="`option-level-${item.level}`" v-text="item.value"></v-list-tile-title>-->
<!--                                </v-list-tile-content>-->
<!--                              </template>-->
<!--                            </v-autocomplete>-->
<!--                          </div>-->
<!--                        </v-flex>-->
<!--                      </v-layout>-->
<!--                    </v-flex>-->
<!--                  </v-layout>-->
<!--                  <v-layout>-->
<!--                    <v-flex xs6>-->
<!--                      <p>Receiving Time</p>-->
<!--                    </v-flex>-->
<!--                    <v-flex xs6 py-0>-->
<!--                      <v-layout row wrap class="time-pick-dropdowns">-->
<!--                        <v-flex md6 sm12 pr-1>-->
<!--                          <div class="dropdown-filter-secondary clearable">-->
<!--                            <v-autocomplete-->
<!--                              v-model="single.dialog.addAlert.receive2.hours.model"-->
<!--                              :items="hours"-->
<!--                              :ripple="false"-->
<!--                              :rules="[v => !!v || 'Item is required']"-->
<!--                              validate-on-blur-->
<!--                              background-color="rgba(235, 237, 242, 0.5)"-->
<!--                              attach-->
<!--                              clearable-->
<!--                              hide-details-->
<!--                              clear-icon="close"-->
<!--                              cache-items-->
<!--                              append-icon="access_time"-->
<!--                              item-text="value"-->
<!--                              item-value="key"-->
<!--                              label="HH"-->
<!--                              solo-->
<!--                              flat-->
<!--                            >-->
<!--                              <template v-slot:item="{ item }">-->
<!--                                <v-list-tile-content>-->
<!--                                  <v-list-tile-title :class="`option-level-${item.level}`" v-text="item.value"></v-list-tile-title>-->
<!--                                </v-list-tile-content>-->
<!--                              </template>-->
<!--                            </v-autocomplete>-->
<!--                          </div>-->
<!--                        </v-flex>-->
<!--                        <v-flex md6 sm12 pl-1>-->
<!--                          <div class="dropdown-filter-secondary clearable">-->
<!--                            <v-autocomplete-->
<!--                              v-model="single.dialog.addAlert.receive2.minutes.model"-->
<!--                              :items="minutes"-->
<!--                              :ripple="false"-->
<!--                              :rules="[v => !!v || 'Item is required']"-->
<!--                              validate-on-blur-->
<!--                              background-color="rgba(235, 237, 242, 0.5)"-->
<!--                              attach-->
<!--                              clearable-->
<!--                              hide-details-->
<!--                              clear-icon="close"-->
<!--                              cache-items-->
<!--                              append-icon="access_time"-->
<!--                              item-text="value"-->
<!--                              item-value="key"-->
<!--                              label="MM"-->
<!--                              solo-->
<!--                              flat-->
<!--                            >-->
<!--                              <template v-slot:item="{ item }">-->
<!--                                <v-list-tile-content>-->
<!--                                  <v-list-tile-title :class="`option-level-${item.level}`" v-text="item.value"></v-list-tile-title>-->
<!--                                </v-list-tile-content>-->
<!--                              </template>-->
<!--                            </v-autocomplete>-->
<!--                          </div>-->
<!--                        </v-flex>-->
<!--                      </v-layout>-->
<!--                    </v-flex>-->
<!--                  </v-layout>-->
                  <div class="text-xs-right">
                    <v-btn
                      type="submit"
                      class="i-btn-hoverable text-normal mx-0 mt-3"
                      flat
                      color="primary"
                      :ripple="false"
                      :disabled="!single.dialog.addAlert.valid"
                    >
                      Save
                    </v-btn>
                  </div>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
    </v-container>

    <!--Delete Dialog-->
    <v-dialog
      v-model="deleteDialog.show"
      transition="slide-x-transition"
      content-class="i-dialog"
      width="500"
      :dark="getThemeColor === '0'"
      attach
    >
      <v-card>
        <v-btn icon dark flat :ripple="false" class="close-icon-absolute" @click="cancelDeleteDialogHandler()">
          <v-icon square>close</v-icon>
        </v-btn>
        <v-card-text class="delete-popup">
          <img src="../assets/img/icons/delete.svg" alt="">
          <h2>Are you sure ?</h2>
          <p>You are about to delete the filter.</p>
          <div class="btn-group justify-center">
            <v-btn
              class="text-normal i-v-btn shadow-0 ml-0"
              :ripple="false"
              color="transparent"
              @click="cancelDeleteDialogHandler()">
              Cancel
            </v-btn>
            <v-btn
              class="text-normal i-v-btn shadow-0 ml-0"
              :ripple="false"
              color="primary"
              :disabled="!deleteDialog.show"
              @click="deleteDialogRequest()">
              Accept
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Save Toaster-->
    <notifications group="save" position="bottom right" :max="toaster.max" width="350">
      <template slot="body" slot-scope="props">
        <div class="default-notification save-notification">
          <a class="close" @click="props.close">
            <v-icon>close</v-icon>
          </a>
          <a class="title">
            <img src="../assets/img/icons/success.svg" alt="">
            {{ props.item.title }}
          </a>
          <p v-html="props.item.text"></p>
        </div>
      </template>
    </notifications>

    <!--Delete Toaster-->
    <notifications group="delete" position="bottom right" :max="toaster.max" width="350">
      <template slot="body" slot-scope="props">
        <div class="default-notification save-notification">
          <a class="close" @click="props.close">
            <v-icon>close</v-icon>
          </a>
          <a class="title danger">
            <img src="../assets/img/icons/cancel.svg" alt="">
            {{ props.item.title }}
          </a>
          <p v-html="props.item.text"></p>
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
export default {
  name: 'Alerts',
  data: () => ({
    multiple: {
      headers: [
        { text: 'Alert Name', value: 'order', sortable: false },
        { text: 'Sellers', value: 'category', sortable: false },
        { text: 'Brands', value: 'brand', sortable: false },
        { text: 'Categories', value: 'price', sortable: false },
        { text: 'Categories', value: null, sortable: false },
        { text: 'Categories', value: null, sortable: false },
        { text: 'Receiving Time', value: null, sortable: false },
        { text: 'Receiving Time', value: null, sortable: false },
        { text: 'Date Created', value: null, sortable: false },
        { text: 'Delete', value: null, sortable: false }
      ],
      rowsPerPageItems: [10, 25, 50, 100],
      pagination: {
        rowsPerPage: 25
      },
      selected: [],
      loading: false,
      dialog: {
        dialogOpen: false,
        addAlert: {
          valid: false,
          errorMsg: '',
          alertName: {
            model: ''
          },
          sellers: {
            isLoading: false,
            items: [],
            model: 0,
            search: null
          },
          brands: {
            isLoading: false,
            items: [],
            model: 0,
            search: null
          },
          categories: {
            isLoading: false,
            items: [],
            model: 0,
            search: null
          },
          receive1: {
            hours: {
              model: ''
            },
            minutes: {
              model: ''
            }
          },
          receive2: {
            hours: {
              model: ''
            },
            minutes: {
              model: ''
            }
          },
          product: {
            model: 0
          }
        }
      }
    },
    single: {
      headers: [
        { text: 'Alert Name', value: null, sortable: false },
        { text: 'Seller', value: null, sortable: false },
        { text: 'Brand', value: null, sortable: false },
        { text: 'Product Name', value: null, sortable: false },
        { text: 'SKU', value: null, sortable: false },
        // { text: 'Receiving Time', value: null, sortable: false },
        // { text: 'Receiving Time', value: null, sortable: false },
        { text: 'Date Created', value: null, sortable: false },
        { text: 'Delete', value: null, sortable: false }
      ],
      rowsPerPageItems: [10, 25, 50, 100],
      pagination: {
        rowsPerPage: 25
      },
      selected: [],
      loading: false,
      dialog: {
        dialogOpen: false,
        addAlert: {
          valid: false,
          alertName: {
            model: ''
          },
          sellers: {
            isLoading: false,
            items: [],
            model: 0,
            search: null
          },
          brands: {
            isLoading: false,
            items: [],
            model: 0,
            search: null
          },
          categories: {
            isLoading: false,
            items: [],
            model: 0,
            search: null
          },
          receive1: {
            hours: {
              model: ''
            },
            minutes: {
              model: ''
            }
          },
          receive2: {
            hours: {
              model: ''
            },
            minutes: {
              model: ''
            }
          },
          products: {
            isLoading: false,
            items: [],
            model: 0,
            search: null
          },
          sku: {
            isLoading: false,
            items: [],
            model: 0,
            search: null
          }
        }
      }
    },
    deleteDialog: {
      show: false,
      type: null,
      id: null
    },
    hours: [],
    minutes: [],
    toaster: {
      max: 3
    },
    time: 3000
  }),
  mounted () {
    this.$store.dispatch('alertsModule/getMultipleAlerts')
    this.$store.dispatch('alertsModule/getSingleAlerts')
  },
  methods: {
    getBrand (item) {
      this.single.dialog.addAlert.brands.model = item.brand_id
      this.single.dialog.addAlert.brands.search = item.brand_name
    },
    changeProductAndBrand (item) {
      this.single.dialog.addAlert.brands.model = item.product.brand_id
      this.single.dialog.addAlert.brands.search = item.product.brand_name
      this.$store.commit('alertsModule/SET_singleProducts', [item.product])
      this.single.dialog.addAlert.products.model = item.product.id
    },
    openMultipleDialog (e, type) {
      this.getTime()
      this.multiple.dialog.dialogOpen = true
      this.multiple.dialog.activeType = type
    },
    closeMultipleDialog () {
      this.multiple.dialog.dialogOpen = false
    },
    openSingleDialog (e, type) {
      this.getTime()
      this.single.dialog.dialogOpen = true
      this.single.dialog.activeType = type
    },
    closeSingleDialog () {
      this.single.dialog.dialogOpen = false
    },
    saveMultiple () {
      if (this.$refs.multipleAlertForm.validate()) {
        this.multiple.dialog.addAlert.valid = true
        this.snackbar = true
      }
      if (this.multiple.dialog.addAlert.brands.model === this.multiple.dialog.addAlert.categories.model && this.multiple.dialog.addAlert.valid === true) {
        this.multiple.dialog.addAlert.errorMsg = true
      } else {
        this.multiple.dialog.addAlert.errorMsg = false
        if (this.multiple.dialog.addAlert.valid === true) {
          this.$store.dispatch('alertsModule/saveMultipleAlert', {
            alertName: this.multiple.dialog.addAlert.alertName.model,
            sellerId: this.multiple.dialog.addAlert.sellers.model,
            brandId: this.multiple.dialog.addAlert.brands.model,
            categoryId: this.multiple.dialog.addAlert.categories.model,
            receive1: String(this.multiple.dialog.addAlert.receive1.hours.model) + String(this.multiple.dialog.addAlert.receive1.minutes.model),
            receive2: String(this.multiple.dialog.addAlert.receive2.hours.model) + String(this.multiple.dialog.addAlert.receive2.minutes.model)
          }).then(() => {
            this.multiple.dialog.dialogOpen = false
            this.$store.dispatch('alertsModule/getMultipleAlerts')
            this.$refs.multipleAlertForm.reset()
            this.$notify({
              group: 'save',
              title: 'New Multiple Alert',
              text: 'New Multiple Alert has been added !',
              duration: 500,
              speed: 600
            })
          })
        }
      }
    },
    saveSingle () {
      if (this.$refs.singleAlertForm.validate()) {
        this.single.dialog.addAlert.valid = true
        this.snackbar = true
      }
      if (this.single.dialog.addAlert.valid === true) {
        this.$store.dispatch('alertsModule/saveSingleAlert', {
          alertName: this.single.dialog.addAlert.alertName.model,
          sellerId: this.single.dialog.addAlert.sellers.model,
          brandId: this.single.dialog.addAlert.brands.model,
          productId: this.single.dialog.addAlert.products.model,
          sku: this.single.dialog.addAlert.sku.model === 0 || !this.single.dialog.addAlert.sku.model ? '' : this.single.dialog.addAlert.sku.model,
          receive1: String(this.single.dialog.addAlert.receive1.hours.model) + String(this.single.dialog.addAlert.receive1.minutes.model),
          receive2: String(this.single.dialog.addAlert.receive2.hours.model) + String(this.single.dialog.addAlert.receive2.minutes.model)
        }).then(() => {
          this.single.dialog.dialogOpen = false
          this.$store.dispatch('alertsModule/getSingleAlerts')
          this.$refs.singleAlertForm.reset()
          this.$notify({
            group: 'save',
            title: 'New Single Alert',
            text: 'New Single Alert has been added !',
            duration: 500,
            speed: 600
          })
        })
      }
    },
    toggleAllSingle () {
      if (this.single.selected.length) this.single.selected = []
      else this.single.selected = this.getAlerts.singleAlerts.slice()
    },
    getTime () {
      if (this.hours.length < 1 || this.minutes.length < 1) {
        for (let i = 0; i <= 23; i++) {
          this.hours.push({key: String(i).length < 2 ? `0${i}` : i, value: String(i).length < 2 ? `0${i}` : i})
        }
        for (let i = 0; i <= 61; i += 5) {
          this.minutes.push({key: String(i).length < 2 ? `0${i}` : i, value: String(i).length < 2 ? `0${i}` : i})
        }
      }
    },
    cancelDeleteDialogHandler () {
      this.deleteDialog.show = false
      this.deleteDialog.type = null
      this.deleteDialog.id = null
    },
    deleteDialogHandler (id, count, type) {
      this.deleteDialog.show = true
      this.deleteDialog.type = type
      this.deleteDialog.id = !Array.isArray(id) ? [id] : id.map(e => e.alert_id)
    },
    deleteDialogRequest () {
      this.deleteDialog.show = false
      this.$store.dispatch('alertsModule/deleteAlerts', {
        alertId: this.deleteDialog.id
      }).then(() => {
        this.deleteDialog.type === 'multiple' ? this.$store.dispatch('alertsModule/getMultipleAlerts') : this.$store.dispatch('alertsModule/getSingleAlerts')
        this.multiple.selected = []
        this.single.selected = []
        this.$notify({
          group: 'delete',
          title: 'Alert Deleted',
          text: 'The ' + this.deleteDialog.type + ' Alert has been deleted !',
          duration: 500,
          speed: 600
        })
        this.cancelDeleteDialogHandler()
      })
    }
  },
  computed: {
    getAlerts () {
      return this.$store.state.alertsModule
    },
    // Multiple
    getMultipleSellers () {
      return this.$store.state.alertsModule.multiple.sellers
    },
    getMultipleBrands () {
      return this.$store.state.alertsModule.multiple.brands
    },
    getMultipleCategories () {
      return this.$store.state.alertsModule.multiple.categories
    },

    // Single
    getSingleSellers () {
      return this.$store.state.alertsModule.single.sellers
    },
    getSingleBrands () {
      return this.$store.state.alertsModule.single.brands
    },
    getSingleProducts () {
      return this.$store.state.alertsModule.single.products
    },
    getSingleSkus () {
      return this.$store.state.alertsModule.single.skus
    },
    getThemeColor () {
      return this.$store.state.auth.userInfo.themeColor
    }
  },
  watch: {
    // Multiple
    'multiple.dialog.addAlert.sellers.search': function (val) {
      if (val === '' || val === null) {
        this.multiple.dialog.addAlert.sellers.model = 0
        this.multiple.dialog.addAlert.sellers.items = []
        return
      }
      if (this.getMultipleSellers && this.getMultipleSellers.find(el => val === el.name)) return
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.multiple.dialog.addAlert.sellers.isLoading = true
        this.$store.dispatch('alertsModule/getMultipleAlertSeller', {
          sellerName: val,
          brandId: this.multiple.dialog.addAlert.brands.model,
          categoryId: this.multiple.dialog.addAlert.categories.model,
          productId: this.multiple.dialog.addAlert.product.model,
          sku: ''
        }).then(() => {
          this.multiple.dialog.addAlert.sellers.isLoading = false
        })
      }, 300)
    },
    'multiple.dialog.addAlert.brands.search': function (val) {
      if (val === '' || val === null) {
        this.multiple.dialog.addAlert.brands.model = 0
        this.multiple.dialog.addAlert.brands.items = []
        return
      }
      if (this.getMultipleBrands && this.getMultipleBrands.find(el => val === el.name)) return
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.multiple.dialog.addAlert.brands.isLoading = true
        this.$store.dispatch('alertsModule/getMultipleAlertBrand', {
          brandName: val,
          categoryId: this.multiple.dialog.addAlert.categories.model,
          sellerId: this.multiple.dialog.addAlert.sellers.model,
          productId: this.multiple.dialog.addAlert.product.model,
          sku: ''
        }).then(() => {
          this.multiple.dialog.addAlert.brands.isLoading = false
        })
      }, 300)
    },
    'multiple.dialog.addAlert.categories.search': function (val) {
      if (val === '' || val === null) {
        this.multiple.dialog.addAlert.categories.model = 0
        this.multiple.dialog.addAlert.categories.items = []
        return
      }
      if (this.getMultipleCategories && this.getMultipleCategories.find(el => val === el.name)) return
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.multiple.dialog.addAlert.categories.isLoading = true
        this.$store.dispatch('alertsModule/getMultipleAlertCategory', {
          categoryName: val,
          brandId: this.multiple.dialog.addAlert.brands.model,
          sellerId: this.multiple.dialog.addAlert.sellers.model,
          productId: this.multiple.dialog.addAlert.product.model,
          sku: ''
        }).then(() => {
          this.multiple.dialog.addAlert.categories.isLoading = false
        })
      }, 300)
    },

    // Single
    'single.dialog.addAlert.sellers.search': function (val) {
      if (val === '' || val === null) {
        this.single.dialog.addAlert.sellers.model = 0
        this.single.dialog.addAlert.sellers.items = []
        return
      }
      if (this.getSingleSellers && this.getSingleSellers.find(el => val === el.name)) return
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.single.dialog.addAlert.sellers.isLoading = true
        this.$store.dispatch('alertsModule/getSingleAlertSeller', {
          sellerName: val,
          brandId: this.single.dialog.addAlert.brands.model,
          categoryId: this.single.dialog.addAlert.categories.model,
          productId: this.single.dialog.addAlert.products.model,
          sku: this.single.dialog.addAlert.sku.model
        }).then(() => {
          this.single.dialog.addAlert.sellers.isLoading = false
        })
      }, 300)
    },
    'single.dialog.addAlert.brands.search': function (val) {
      if (val === '' || val === null) {
        this.single.dialog.addAlert.brands.model = 0
        this.single.dialog.addAlert.brands.items = []
        return
      }
      if (this.getSingleBrands && this.getSingleBrands.find(el => val === el.name)) return
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.single.dialog.addAlert.brands.isLoading = true
        this.$store.dispatch('alertsModule/getSingleAlertBrand', {
          brandName: val,
          categoryId: this.single.dialog.addAlert.categories.model,
          sellerId: this.single.dialog.addAlert.sellers.model,
          productId: this.single.dialog.addAlert.products.model,
          sku: this.single.dialog.addAlert.sku.model
        }).then(() => {
          this.single.dialog.addAlert.brands.isLoading = false
        })
      }, 300)
    },
    'single.dialog.addAlert.products.search': function (val) {
      if (val === '' || val === null) {
        this.single.dialog.addAlert.products.model = 0
        this.single.dialog.addAlert.products.items = []
        return
      }
      if (this.getSingleProducts && this.getSingleProducts.find(el => val === el.name)) return
      if (this.single.dialog.addAlert.sku.model !== 0) {
        this.single.dialog.addAlert.sku.model = 0
        this.$store.commit('alertsModule/RESET_singleSkus')
      }
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.single.dialog.addAlert.products.isLoading = true
        this.$store.dispatch('alertsModule/getSingleAlertProduct', {
          productName: val,
          categoryId: this.single.dialog.addAlert.categories.model,
          sellerId: this.single.dialog.addAlert.sellers.model,
          brandId: this.single.dialog.addAlert.brands.model,
          sku: this.single.dialog.addAlert.sku.model
        }).then((res) => {
          this.single.dialog.addAlert.products.isLoading = false
        })
      }, 300)
    },
    'single.dialog.addAlert.sku.search': function (val) {
      if (val === '' || val === null) {
        this.single.dialog.addAlert.sku.model = 0
        this.single.dialog.addAlert.sku.items = []
        return
      }
      if (this.getSingleSkus && this.getSingleSkus.find(el => val === el.name)) return
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.single.dialog.addAlert.sku.isLoading = true
        this.$store.dispatch('alertsModule/getSingleAlertSku', {
          sku: val,
          categoryId: this.single.dialog.addAlert.categories.model,
          sellerId: this.single.dialog.addAlert.sellers.model,
          brandId: this.single.dialog.addAlert.brands.model,
          productId: this.single.dialog.addAlert.products.model
        }).then(() => {
          this.single.dialog.addAlert.sku.isLoading = false
        })
      }, 300)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Alerts.vue